module.exports = __webpack_public_path__ + "static/img/23.c9bdf11e.png";